import { useTranslations } from 'next-intl';
import {
  Card,
  Button,
  Subline,
  LogoContainer,
  StarsContainer,
} from './Trustpilot.styles';

type Props = {
  className?: string;
  /** `stacked` shows the logo above the stars. */
  layout?: 'inline' | 'stacked';
  /** Shows the rating label after the number of reviews. */
  showLabel?: boolean;
  label: string;
  link: string;
  logo: string;
  numberOfReviews: number;
  stars: string;
  trustScore: number;
};

const Trustpilot = ({
  label,
  link,
  logo,
  numberOfReviews,
  stars,
  trustScore,
  className,
  layout = 'inline',
  showLabel = true,
}: Props) => {
  const t = useTranslations('features.trustElements.trustpilot');

  const handleClick = () => {
    window.open(link, '_blank');
  };

  if (!logo || !stars) {
    return null;
  }

  return (
    <Card aria-label={t('label')} className={className}>
      <Button type="button" onClick={handleClick} $layout={layout}>
        <LogoContainer
          dangerouslySetInnerHTML={{ __html: logo }}
          aria-hidden="true"
        />
        <StarsContainer
          dangerouslySetInnerHTML={{ __html: stars }}
          aria-hidden="true"
        />
        <Subline>
          <data value={trustScore}>
            {t('trustScore', { score: trustScore })}
          </data>{' '}
          | <strong>{t('reviews', { numberOfReviews })}</strong>
          {showLabel && <> | {label}</>}
        </Subline>
      </Button>
    </Card>
  );
};

export { Trustpilot };
